import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
// hooks
import { useLanguageManager } from 'src/hooks/use-language-manager';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { t, i18n } = useTranslation();
  const languageManager = useLanguageManager();

  // Sync i18n with language manager when language changes
  useEffect(() => {
    if (i18n.language !== languageManager.currentLang.value) {
      i18n.changeLanguage(languageManager.currentLang.value);
    }
  }, [languageManager.currentLang.value, i18n]);

  return {
    allLangs: languageManager.allLangs,
    currentLang: languageManager.currentLang,
    isRTL: languageManager.isRTL,
    t,
    translate: t,
    onChangeLang: languageManager.changeLanguage,
  };
}
